import * as React from 'react';
import {
  FaDownload,
  FaTwitter,
  FaInstagram,
  FaRecordVinyl,
} from 'react-icons/fa';

function OwnedNftCard(props) {
  function downloadImage() {
    const link = document.createElement('a');
    link.href = `https://arweave.net/ikXRO73MyoTM0yCKYypmRkMX_r95BrGXmCT7RYICyf8/${props.id}.0.jpg`;
    link.download = `${props.collectionName}_${props.id}.0.jpg`;
    link.rel = 'noopener noreferrer'; // add this line
    link.target = '_blank'; // add this line
    link.click();
  }

  function shareOnTwitter() {
    const url = `https://twitter.com/intent/tweet?text=Just%20minted%20a%20${props.collectionName}%20${props.id}.0%20NFT%21&url=https://arweave.net/ikXRO73MyoTM0yCKYypmRkMX_r95BrGXmCT7RYICyf8/${props.name}.0.jpg`;
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  function shareOnInstagram() {
    const url = `https://www.instagram.com/create/post/?title=Just%20minted%20a%20${props.collectionName}%20${props.id}.0%20NFT%21&media=https://arweave.net/ikXRO73MyoTM0yCKYypmRkMX_r95BrGXmCT7RYICyf8/${props.name}.0.jpg`;
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  function thankYou() {
    const url = 'https://facingthesky.io/thank-you/';
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  return (
    <div className='card card-compact max-w-full bg-base-100 shadow-xl'>
      <figure>
        <img
          className='max-w-full h-auto'
          src={`https://arweave.net/ikXRO73MyoTM0yCKYypmRkMX_r95BrGXmCT7RYICyf8/${props.id}.0.jpg`}
          alt={`SKYFACE ${props.id}.0`}
        />
      </figure>
      <div className='card-body items-center text-center'>
        <h3 className='card-title'>
          {props.collectionName} {props.id}.0
        </h3>
        <div className='card-actions justify-center'>
          <button className='btn btn-primary btn-sm' onClick={downloadImage}>
            <FaDownload className='btn-icon' />
          </button>
          <button className='btn btn-twitter btn-sm' onClick={shareOnTwitter}>
            <FaTwitter className='btn-icon' />
          </button>
          <button
            className='btn btn-instagram btn-sm'
            onClick={shareOnInstagram}
          >
            <FaInstagram className='btn-icon' />
          </button>
          <button className='btn btn-sm' onClick={thankYou}>
            <FaRecordVinyl className='btn-icon' />
          </button>
        </div>
      </div>
    </div>
  );
}
export function OwnedNfts(props) {
  return (
    <>
      <div>
        <br></br>
      </div>
      <h1 className='text-3xl font-bold' style={{ color: '#0178db' }}>
        Your Collection of Minted SKYFACEs:
      </h1>
      <div>
        <br></br>
      </div>
      <div className='grid grid-cols-3 md:grid-cols-7 xl:grid-cols-10 gap-4'>
        {props.ids &&
          props.ids.map((id) => (
            <OwnedNftCard
              key={id}
              id={id}
              collectionName={props.collectionName}
            />
          ))}
      </div>
    </>
  );
}
